import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import trackGTM from 'utils/trackGTM'
import GA4 from 'utils/GA4'

import { Method, MethodIcon, Row } from './BrandContactMethods.style'

const BrandContactMethods = ({
  methods,
  brandName,
  villageName,
  headerTitle,
}) => {
  return (
    <Row>
      {methods.map(
        ({
          trackLabel,
          icon,
          label,
          link,
          showExternalIcon,
          onClickCallback = () => null,
        }) => (
          <Method>
            <MethodIcon dangerouslySetInnerHTML={{ __html: icon }} />
            <Link
              external
              showIcon={showExternalIcon}
              to={link}
              onClick={() => {
                trackGTM(
                  'Virtual Shopping',
                  'Virtual Shopping icon click',
                  brandName,
                  trackLabel
                )
                GA4('virtual_shopping_contact_click', {
                  village_name: villageName,
                  brand_name: brandName,
                  component_location: headerTitle,
                  contact_type: trackLabel,
                })
                onClickCallback()
              }}>
              {label}
            </Link>
          </Method>
        )
      )}
    </Row>
  )
}

BrandContactMethods.propTypes = {
  methods: PropTypes.arrayOf(
    PropTypes.shape({
      trackLabel: PropTypes.string,
      icon: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
      showExternalIcon: PropTypes.bool,
    })
  ),
  brandName: PropTypes.string,
  villageName: PropTypes.string,
  headerTitle: PropTypes.string,
}

BrandContactMethods.defaultProps = {
  methods: [],
  brandName: '',
  villageName: '',
  headerTitle: '',
}

export default BrandContactMethods
